import { SendMailRequest, SendMailResponse } from 'src/models/SendMail';

export const sendMail = async (
    data: SendMailRequest,
    token: string,
): Promise<SendMailResponse> => {
    const urlAlerts = `${process.env.REACT_APP_GLOBAL_ALERTS}mail/send`;

    const requestOptions: RequestInit = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_ALERTS_XAPIKEY as string,
        },
        body: JSON.stringify(data),
    };

    const res = await fetch(urlAlerts, requestOptions);
    return res.json();
};
